import React, { Fragment } from 'react';
import { FovSlider, FovToggle, VerticalSpacer } from 'components';
import {
  LabeledSliderContainer,
  OptimizationControlContainer,
  OptimizationTogglesContainer,
  ToggleContainer,
} from './RPCFormStyles';

const OptimizationSettings = ({
  useModelOptimization,
  optimizationAmount,
  setOptimizationAmount,
  estimatedFacesCount,
}) => {
  if (!useModelOptimization) {
    return null;
  }

  return (
    <OptimizationControlContainer>
      Estimated mesh faces count:&nbsp;
      {Math.round(estimatedFacesCount)?.toLocaleString()}

      <LabeledSliderContainer>
        <FovSlider
          label='Amount'
          defaultValue={optimizationAmount}
          min={0.01}
          max={0.99}
          onChange={value => setOptimizationAmount(value)}
        />
      </LabeledSliderContainer>
    </OptimizationControlContainer>
  );
};

const OptimizationSection = ({
  compactRPCEnabled,
  useModelOptimization,
  optimizationAmount,
  setOptimizationAmount,
  estimatedFacesCount,
  onCompactRPCChange,
  onModelOptimizationChange,
}) => {
  return (
    <Fragment>
      <OptimizationTogglesContainer>
        <ToggleContainer>
          Use Compact RPC

          <FovToggle
            checked={!!compactRPCEnabled}
            disabled={useModelOptimization}
            callback={onCompactRPCChange}
          />
        </ToggleContainer>

        <VerticalSpacer size={10} />

        <ToggleContainer>
          Use Model Optimization

          <FovToggle
            checked={!!useModelOptimization}
            disabled={compactRPCEnabled}
            callback={onModelOptimizationChange}
          />
        </ToggleContainer>

        <OptimizationSettings
          useModelOptimization={useModelOptimization}
          optimizationAmount={optimizationAmount}
          setOptimizationAmount={setOptimizationAmount}
          estimatedFacesCount={estimatedFacesCount}
        />

        <VerticalSpacer size={25} />
      </OptimizationTogglesContainer>
    </Fragment>
  );
};

export default OptimizationSection;

